import type { LegacyBillcheckState } from './legacyBillCheck';
import type { BillcheckV3State } from './billCheckV3';
import type { DepositState } from './deposit';
import type { InsuranceState } from './productBenefits';
import type { StorageboxState } from './storagebox';
import type { TenantProtectionState } from './tenantProtection';
import type { InsurancePackageState } from './insurance';

export interface ProductsStatusResponse {
  autoContactAgent?: { plusProduct: boolean };
  billcheck?: LegacyBillcheckState;
  billcheckV3?: BillcheckV3State;
  deposit?: DepositState;
  profileBenefits?: InsuranceState;
  lagerbox?: StorageboxState;
  tenantProtection?: TenantProtectionState;
  insurancePackage?: InsurancePackageState;
}

export enum ProductsStatusKey {
  Billcheck = 'billcheck',
  BillcheckV3 = 'billcheckV3',
  Deposit = 'deposit',
  ProfileBenefits = 'profileBenefits',
  Lagerbox = 'lagerbox',
  TenantProtection = 'tenantProtection',
  insurancePackage = 'insurancePackage',
}

export interface ProductsStatus extends ProductsStatusResponse {
  calendar?: CalendarRes;
  schufa?: SolvencyRes;
}

export interface SolvencyRes {
  expirationDate?: string;
  verificationCode?: string;
}

export type CalendarRes = {
  appointmentId?: string;
  startDate?: string;
  startTime?: string;
  endDate?: string;
  endTime?: string;
  pictureUrl?: string | null;
  exposeId?: number | null;
  title?: string | null;
  status?: string | null;
  address?: string | null;
  phone?: string | null;
  contactPerson?: string | null;
  exposeBuyPrice?: number | null;
  exposeBaseRentPrice?: number | null;
  version?: number | null;
  allInviteEventsSeen?: boolean | null;
}[];
